import Section from "./Section";
import { contactDetails, translations, type Lang } from "../content";

export default function Contact({ lang }: { lang: Lang }) {
  const t = translations[lang];
  const col =
    "py-10 lg:py-0 lg:px-10 first:ltr:lg:pl-0 first:rtl:lg:pr-0 flex flex-col items-start gap-4";

  /*
   * The links are styled as pills directly. Do not wrap a <button> inside the
   * <a>: interactive content inside a link is invalid HTML, and the button
   * becomes the click target, so the link never navigates.
   */
  const action = "pill px-6 py-3 text-sm no-underline";

  return (
    <Section id="contact" className="border-t border-border/10">
      <div dir={lang === "he" ? "rtl" : "ltr"}>
        <div className="mb-14 md:mb-20">
          <h2 className="display-lg text-4xl md:text-5xl lg:text-6xl text-foreground">
            {t.contact.title}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground mt-4 font-light">
            {t.contact.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 divide-y lg:divide-y-0 lg:divide-x rtl:lg:divide-x-reverse divide-border/10">
          <div className={col}>
            <p className="eyebrow">{t.contact.phone}</p>
            <p className="display-lg text-3xl md:text-4xl text-foreground" dir="ltr">
              {contactDetails.phone.display}
            </p>
            <a href={contactDetails.phone.href} className={action}>
              {t.contact.callNow}
            </a>
          </div>

          <div className={col}>
            <p className="eyebrow">{t.contact.whatsapp}</p>
            <p className="display-lg text-3xl md:text-4xl text-foreground" dir="ltr">
              {contactDetails.whatsapp.display}
            </p>
            <a
              href={contactDetails.whatsapp.href}
              target="_blank"
              rel="noopener noreferrer"
              className={action}
            >
              {t.contact.openWhatsapp}
            </a>
          </div>

          <div className={col}>
            <p className="eyebrow">{t.contact.email}</p>
            <p
              className="display-lg text-xl md:text-2xl lg:text-3xl text-foreground break-all"
              dir="ltr"
            >
              {contactDetails.email}
            </p>
            <a href={`mailto:${contactDetails.email}`} className={action}>
              {t.contact.sendEmail}
            </a>
          </div>
        </div>
      </div>
    </Section>
  );
}
